/**
 * Get focusable element/elements
 * @return {array}
 */

import focusableElementSelector from '../focusable-elements/u-focusable-elements.js';

const getFocusableElement = (element) => {
	return element.querySelector(focusableElementSelector);
};

const getFocusableElements = (element) => {
	return element.querySelectorAll(focusableElementSelector);
};

export {getFocusableElement, getFocusableElements};

export default getFocusableElement;



// WEBPACK FOOTER //
// ./js/utilities/get-focusable-element/u-get-focusable-element.js